import React from "react";
import PropTypes from "prop-types";
import { ButtonGroupStyle } from "./ButtonGroupStyle";
import labels from "../../../config/labels";
import config from "../../../config/index";

const ButtonGroup = (props) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const toggleVal = props.filterType ? props.filterType : "filter";

  const generateImageUrl = () => {
    switch (props.filterType) {
      case "filter":
        return `${imagePrefix}/assets/images/filter.svg`;
      case "search":
        return `${imagePrefix}/assets/images/search.svg`;
      default:
        return `${imagePrefix}/assets/images/filter.svg`;
    }
  };

  return (
    <div>
      {props.hide ? (
          <div className="hide">
            <div className="d-block d-lg-none">
              <button className="left-btn" onClick={() => props.toggleComps(toggleVal)}>
                Filter
              </button>
            </div>
          </div>
        ) :
        <div>
          <div>
            <button className={`filters-mobile-button ${props.noShadow ? "no-shadow" : ""} left-btn-md pl-0`} onClick={() => props.toggleComps(toggleVal)} id={`${labels.lbl_filter_products}-fiter-arrow`}>
              <img className="button-image" src={generateImageUrl()} alt="filter" />
              <span className="button-label"> {props.buttonLabel ? props.buttonLabel : labels.lbl_filter_products}</span>
            </button>
          </div>
        </div>
      }
      <style jsx>{ButtonGroupStyle}</style>
    </div>
  );
};

ButtonGroup.propTypes = {
  hide: PropTypes.bool,
  toggleComps: PropTypes.func,
  selectedSortVal: PropTypes.string,
  buttonLabel: PropTypes.string,
  filterType: PropTypes.string,
  noShadow: PropTypes.bool,
};

export default ButtonGroup;
